// @LTG-ID: data/journals/how-long-does-it-take-to-sell-a-business
// @STATUS: BUILT
// @HERMETIC: true
// @DOCS: /app/docs/data-model/journal_content_v1.md, /app/docs/09_CHANGELOG.md#CHG-0107
// @CHANGED: 2026-07-06 (CHG-0107 · Journals content port from batch MD)
// @OWNER: web
//
// Article 6 of 20. Source: batch MD at /app/_ltg_analysis/content_batches/.
// Byline: LTG Team (per CHG-0107 orchestrator Decision 2 / batch preamble directive).

export const BRIEF = {
    SLUG: "how-long-does-it-take-to-sell-a-business",
    FRONTMATTER: {
        number: "43",
        section: "Exit Planning",
        sectionHref: "/journals#exit-planning",
        sectionAnchor: "exit-planning",
        title: "How Long Does It Take to Sell a Business?",
        deck: "Selling a small business typically takes six to eleven months from listing to closing, according to industry surveys such as the IBBA Market Pulse.",
        author: "LTG Team",
        authorRole: "",
        authorInitials: "LT",
        publishedISO: "2026-04-27",
        publishedHuman: "April 27, 2026",
        lastReviewed: "2026-08-27",
        readMinutes: 3,
        wordCount: 302,
        timeRequired: "PT3M",
        keywords: "how long does it take to sell a business, business sale timeline, time to sell small business",
        articleSection: "Exit Planning",
        articleBodyPreview: "Selling a small business typically takes six to eleven months from listing to closing, according to industry surveys such as the IBBA Market Pulse. Preparation before listing adds more time. Well prepared businesses with clean financials and reasonable pricing sell faster; overpriced or owner dependent businesses take longer or never sell. The single biggest surprise for first time sellers is not the price. It is the clock. The typical timeline Industry surveys, including the IBBA Market Pulse p",
        complianceNote: "This article is educational and does not constitute financial, legal, or tax advice.",
        needsDisclaimerFooter: false,
        internalLinks: [
        "exit-planning-guide",
        "what-percentage-of-businesses-sell",
        "asset-sale-vs-stock-sale"
    ],
        ctaId: "journal-article-primary",
        ctaLabel: "Get Your Valuation",
        pageTitle: "How Long Does It Take to Sell a Business?",
        canonical: "https://letstalkgrowth.com/journals/how-long-does-it-take-to-sell-a-business",
        ogImage: "/journals/og/how-long-does-it-take-to-sell-a-business.jpg",
    },
    BODY_MARKDOWN: `Selling a small business typically takes six to eleven months from listing to closing, according to industry surveys such as the IBBA Market Pulse. Preparation before listing adds more time. Well-prepared businesses with clean financials and reasonable pricing sell faster; overpriced or owner-dependent businesses take longer or never sell.

The single biggest surprise for first-time sellers is not the price. It is the clock.

## The typical timeline

Industry surveys, including the IBBA Market Pulse published by the International Business Brokers Association, have consistently reported that Main Street businesses take somewhere in the range of six to eleven months to move from listing to closing, with larger deals often taking longer. BizBuySell's transaction data tells a similar story. And that clock starts at listing: the preparation phase before a business is ready to go to market adds months more for owners starting cold.

## What the months are spent on

Roughly, the process breaks into four stretches. Preparation covers financial cleanup, valuation, and marketing materials. Marketing covers confidentially finding and qualifying buyers, often the longest and least predictable stretch. Negotiation covers offers, terms, and the letter of intent. Diligence and closing covers the buyer's verification of everything, plus financing, legal documents, and, where relevant, landlord and license transfers. SBA-financed deals add lender underwriting to the critical path.

## What makes sales faster or slower

Three factors dominate. Pricing: businesses priced against real market evidence attract offers; overpriced listings age, and stale listings raise buyer suspicion. Records: buyers move quickly when the numbers are clean and verifiable, and stall when every figure needs explanation. Transferability: a business that clearly runs without its owner shortens diligence, while heavy owner dependence invites extended transition negotiations, earnouts, or withdrawal.

The lesson is unglamorous but reliable: the fastest sales are prepared years before they are launched.`,
    FAQ: [
        { question: "Can I sell my business in under six months?", answer: "It happens, usually when a business is well prepared, sensibly priced, and lands a motivated, financed buyer early. Planning around a fast sale, however, is a mistake; the process contains stages you do not control." },
        { question: "Why do so many listed businesses never sell?", answer: "Overpricing, poor records, owner dependence, and owner fatigue during the long process are the leading causes cited across industry research. Many listings quietly expire rather than closing." },
        { question: "Does using a broker speed things up?", answer: "A good broker widens the buyer pool, keeps the process confidential, and keeps momentum through diligence, which often shortens the timeline. The trade-off is a commission, typically justified when the broker brings real buyer reach." }
    ],
    SOURCES: [

    ],
    END_CTA: {
        label: "READY TO KNOW YOUR NUMBER?",
        headlineLead: "What is your business ",
        headlineEm: "actually",
        headlineTrail: " worth?",
        body: "Indicative valuation signed by Sara. $995 flat.",
        secondaryHref: "/journals",
        secondaryLabel: "More from the Journal →",
        microLine: "· 7-DAY DELIVERY · KGOB METHODOLOGY, NC CPA #30420 ·",
    },
    READ_NEXT: [
        {
            tag: "Exit Planning",
            title: "Exit Planning 101: How to Leave Your Business on Your Own Terms",
            meta: "4 min · Brief 39",
            to: "/journals/exit-planning-guide",
        },
        {
            tag: "Exit Planning",
            title: "What Percentage of Businesses Actually Sell? The Statistics Every Owner Should See",
            meta: "3 min · Brief 44",
            to: "/journals/what-percentage-of-businesses-sell",
        },
        {
            tag: "Deal Process",
            title: "Asset Sale vs Stock Sale: What Every Seller Should Understand Before Negotiating",
            meta: "3 min · Brief 46",
            to: "/journals/asset-sale-vs-stock-sale",
        },
    ],
};

export default BRIEF;
